import { Alert, Button, Icon, ModalDialog } from 'vetrf-ui';
import { EaeuInfo } from 'api/eaeu/types';
import styles from './ResultTransactionsModal.module.scss';

type ResultTransactionsModalProps = {
  responseInfo: EaeuInfo[] | { message: string } | null;
  onClose: () => void;
};

export const ResultTransactionsModal = ({
  responseInfo,
  onClose,
}: ResultTransactionsModalProps) => {
  const copyErrorText = (blockId: string) => {
    const range = document.createRange();
    const copyElement = document.getElementById(blockId);
    range.selectNode(copyElement as Node);
    window.getSelection()?.removeAllRanges();
    window.getSelection()?.addRange(range);
    document.execCommand('copy');
    window.getSelection()?.removeAllRanges();
  };

  return (
    <ModalDialog
      header="Результат отправки"
      headerClass="modal-header modal-large"
      bodyClass="modal-body scrollable"
      onClose={onClose}
      footer={
        <Button
          color="grey"
          icon="times"
          iconColor="white"
          iconSize={100}
          onClick={onClose}
          size="sm"
          text="Закрыть"
        />
      }
    >
      {!!responseInfo && Array.isArray(responseInfo) ? (
        responseInfo?.map(({ message, transactionType: { id, name } }) => (
          <Alert key={id} messageType={message ? 'danger' : 'success'} id={`block_${id}`}>
            <p className="d-flex align-items-center gap-5">
              <Icon icon={message ? 'exclamation-circle' : 'check-circle'} className="m-right" />
              <b>{name || 'Ошибка'}</b>
              {!!message && (
                <Button
                  className="alert-link ml-auto"
                  icon="copy"
                  onlyIcon
                  iconSize={100}
                  onClick={() => copyErrorText(`block_${id}`)}
                  title="Копировать текст ошибки"
                />
              )}
            </p>
            {!!message && (
              <>
                <br />
                <pre className={styles.responseText}>{message}</pre>
              </>
            )}
          </Alert>
        ))
      ) : (
        <Alert messageType="danger">{responseInfo?.message}</Alert>
      )}
    </ModalDialog>
  );
};
